"use client"

import { MoveUpRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MoveUpRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MoveUpRightIcon = component(Icon)({ as: MoveUpRight })
